<template>
  <div class="user">
    <div class="d-s-c">
      <el-button size="small" type="primary" @click="batchAdd()" icon="el-icon-plus">添加到易错题排行榜</el-button>
      <div class="ml10 mt10 d-s-c">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="">
            <el-button-group>
              <!-- <el-button @click="changeTypeFunc('')">不限</el-button> -->
              <el-button :type="formInline.type == 10 ? 'primary' : ''" plain @click="changeTypeFunc(10)">刷题</el-button>
              <el-button :type="formInline.type == 71 ? 'primary' : ''" plain @click="changeTypeFunc(71)">真题训练</el-button>
              <!-- <el-button :type="formInline.type == item.key_name ? 'primary' : ''" plain v-for="(item, index) in typeData" :key="index" @click="changeTypeFunc(item.key_name)">{{item.name}}</el-button> -->
            </el-button-group>
          </el-form-item>
          <!--上级分类-->
          <el-form-item label="分类" prop="category_id" v-if="formInline.type > 0">
            <el-cascader size="small" v-model="parentsVal" :options="cateList" :props="propsParam" @change="handleChange" v-if="cateList.length>0"></el-cascader>
            <p class="gray9" v-else>暂无</p>
          </el-form-item>
          <el-form-item label="答题">
            <el-input v-model="formInline.question" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="答题id">
            <el-input v-model="formInline.question_id" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      
    </div>
    <!--内容-->
    <div class="product-content mt10">
      <div class="table-wrap">
        <el-table size="small" :data="tableData.filter(data => !search || data.question.toLowerCase().includes(search.toLowerCase()))"
            border style="width: 100%" v-loading="loading" @sort-change="sortChange" :row-key="getRowKey"  @selection-change="tableCurrentChange">
          <el-table-column type="selection" :reserve-selection="true" :selectable="selectEnable" align="center" width="45"></el-table-column>
          <el-table-column prop="question_id" label="ID" width="80"></el-table-column>
          <el-table-column prop="type" label="类型" width="100" align="center">
            <template slot-scope="scope">
              {{ scope.row.type == 71 ? '真题训练' : '刷题'}}
            </template>
          </el-table-column>
          <el-table-column prop="question" label="答题(蓝字为已选)">
            <template slot="header" slot-scope="scope">
              <div class="d-s-c">
                <span style="width: 200px">答题(蓝字为已选)</span>
                <el-input v-model="search" size="mini" placeholder="关键字搜索" clearable/>
              </div>
            </template>
            <template slot-scope="scope">
              <span v-if="ids.indexOf(scope.row.question_id) != -1" class="blue fb" v-html="scope.row.question"></span>
              <span v-else v-html="scope.row.question"></span>
            </template>
          </el-table-column>
          <el-table-column prop="error_count" label="错题数量" align="center" sortable="custom"></el-table-column>
          <el-table-column prop="user_count" label="错题人数/做题人数" align="center">
            <template slot-scope="scope">
              {{ scope.row.user_count +'/'+ scope.row.user_all_count }}
            </template>
          </el-table-column>
          <el-table-column prop="error_rate" label="错误率(%)" align="center" sortable="custom"></el-table-column>
          <el-table-column prop="answer_type" label="答案类型" width="100" align="center">
            <template slot-scope="scope">
              {{ answer_type[scope.row.answer_type].name }}
            </template>
          </el-table-column>
          <el-table-column prop="content" label="关联答题" width="130" align="center">
            <template slot-scope="scope">
              <el-button size="mini" href="/" target="_blank" @click="onDetail(scope.row)">查看答题</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import QuestionErrorApi from '@/api/study/question_error.js';
  import QuestionErrorrankingLogApi from '@/api/study/question_errorranking_log.js';
  import CategoryApi from '@/api/study/category.js';
  import qs from 'qs';
  export default {
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        formInline: {
          type: 10,
          category_id: 0,
          question: '',
          question_id: '',
        },
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        answer_type: {},
        selectItems: [],
        ids: [],
        typeData: [],
        search: '',
        /*当前父集ID*/
        parentsVal: [],
        /*分类列表*/
        cateList: [],
        /*展示数据*/
        propsParam: {
          label: 'name',
          value: 'category_id',
          checkStrictly: true
        },
      };
    },
    created() {
      const params = this.$route.query;
      Object.assign(this.formInline, params);

      /*获取列表*/
      this.getCateList();
      this.getTableList();
    },
    methods: {
      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.curPage = 1;
        let Params = self.formInline;
        self.getTableList();
      },
      /*选择分类*/
      handleChange(e) {
        this.formInline.category_id = e[0];
        console.log(this.formInline);
        this.getTableList();
      },
      /*选择类型*/
      changeTypeFunc(e){
        this.formInline.type = e;
        this.getCateList();
        this.getTableList();
      },
      /*获取列表*/
      getCateList() {
        let self = this;
        let Params = this.formInline;
        CategoryApi.getList(Params, true)
          .then(res => {
            self.loading = false;
            self.typeData = res.data.type;  
            self.cateList = res.data.list          
          })
          .catch(error => {
            self.loading = false;
          });
      },
      // 已选中，禁用
      selectEnable(row, rowIndex) {
        return this.ids.indexOf(row.question_id)!=-1 ? false : true;
      },
      // 保存选中的数据id,row-key就是要指定一个key标识这一行的数据
      getRowKey (row) {
        return row.question_id;
      },
      /*监听复选按钮选中事件*/
      tableCurrentChange(val) {
        this.selectItems = [];
        val.forEach(e => {
          this.selectItems.push(e);
        });
      },
      batchAdd(){
        let self = this
        if (!this.selectItems.length){
          self.$message({
            message: '请选择答题',
            type: 'warning'
          });
          return;
        }
        let content = JSON.stringify(this.selectItems);
        QuestionErrorApi.batch({content:content}, true)
          .then(res => {
            if (res.code == 1) {
              self.$message({
                message: res.msg,
                type: 'success'
              });
              self.loading = false;
              self.$parent.handleClick({name: 'show'});
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*跳转详情*/
      onDetail(row) {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        let params = {question_id: row.question_id};
        baseUrl = this.$filter.isDebug() ? '' : '/shop';
        window.open(baseUrl + '/#/study/questionlibrary/index?' + qs.stringify(params));
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.sort_name = self.sortName;
        Params.sort_value = self.sortValue;
        QuestionErrorrankingLogApi.getList(Params, true).then(res => {
          let data = res.data;
          self.loading = false;
          self.tableData = data.list.data;
          self.totalDataNumber = data.list.total;
          self.answer_type = data.answer_type;
          self.ids = data.ids;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*排序查询*/
      sortChange(e){
        if (e.order && e.order != null){
          this.sortName = e.prop;
          this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
        }else{
          this.sortName = this.sortValue = '';
        }
        this.tableData = [];
        this.getTableList();
      },

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/study/questionerrorranking/part/Ranking.vue